module.exports = "/fonts/vendor/devextreme/dist/css/icons/dxicons.ttf?cc887dc822e29b9dc043c51634c387e3";